import { DealerClaimType } from '@core/enums/dealer-claim-type';
import { rootPaths } from '../constants/paths';

export const diegoRoutes = {
  login: '/login',
  startSale: '/sales/startsale',
  registerCustomer: '/support/customer/register',
  orderDetails: '/support/order-details',
  orderHistory: '/support/order-history',
  sellers: '/support/sellers',
  newsfeed: '/support/newsfeed',
  supportDetails: '/support/support-details',
  orderBulkSim: '/support/order-sim',
  competition: '/support/competition',
  battlecards: '/support/battlecards',
  salesBattle: '/support/sales-battle',
};

export const hideSalesHeaderAndFooterOnRoute = rootPaths.summary;

export const salesFlowRoutes = [
  {
    route: rootPaths.details,
    text: 'Kunde',
    claimType: null,
  },
  {
    route: rootPaths.subscription,
    text: 'Abonnement',
    claimType: DealerClaimType.DiegoVoiceFunctionality,
  },
  {
    route: rootPaths.equipment,
    text: 'Utstyr',
    claimType: DealerClaimType.CanSellMobilePhone,
  },
  {
    route: rootPaths.mbb,
    text: 'Bredbånd',
    claimType: DealerClaimType.DiegoMbbFunctionality,
  },
];
